import { Component, ChangeDetectionStrategy, input, output, signal, inject, ElementRef, viewChild } from '@angular/core';
import { Upload } from '@xmedical/core';
import { FileUploaderService } from '../../services/file-uploader.service';

@Component({
  selector: 'xmed-file-downloader',
  exportAs: 'libFileDownloader',
  standalone: true,
  imports: [],
  templateUrl: './file-downloader.component.html',
  styleUrl: './file-downloader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// Angular workaround: uses setTimeout + nativeElement.click() to open the link
// once the view has updated with the new signed URL value.
// TODO: Look into having in app preview rather than this hacky method
export class FileDownloaderComponent {
  private readonly fileUploadService = inject(FileUploaderService);
  private readonly fileLink = viewChild<ElementRef<HTMLAnchorElement>>('fileLink');

  upload = input.required<Upload>();
  processing = output<boolean>();

  fileUrl = signal('');

  openUpload(): void {
    this.processing.emit(true);
    const upload = this.upload();
    if (upload.legacy) {
      this.openLegacyAttachment();
    } else {
      this.openCloudfrontAttachment();
    }
  }

  openGeneratedReport(): void {
    this.processing.emit(true);
    const upload = this.upload();
    this.fileUploadService.getSignedReportsUrl(upload.path, 'GET', 300).subscribe({
      next: (url) => {
        this.fileUrl.set(url);
        setTimeout(() => {
          this.processing.emit(false);
          this.fileLink()?.nativeElement.click();
        }, 1);
      },
      error: (err) => {
        this.processing.emit(false);
        console.error('Failed to get report URL:', err);
      }
    });
  }

  private openLegacyAttachment(): void {
    const upload = this.upload();
    this.fileUploadService.getSignedUrl(upload.path, 'GET', 300).subscribe({
      next: (url) => {
        this.fileUrl.set(url);
        setTimeout(() => {
          this.processing.emit(false);
          this.fileLink()?.nativeElement.click();
        }, 1);
      },
      error: (err) => {
        this.processing.emit(false);
        console.error('Failed to get legacy URL:', err);
      }
    });
  }

  private openCloudfrontAttachment(): void {
    const upload = this.upload();
    this.fileUploadService.getSignedUploadsUrl(upload.path, 'GET', 300).subscribe({
      next: (url) => {
        this.fileUrl.set(url);
        setTimeout(() => {
          this.processing.emit(false);
          this.fileLink()?.nativeElement.click();
        }, 1);
      },
      error: (err) => {
        this.processing.emit(false);
        console.error('Failed to get cloudfront URL:', err);
      }
    });
  }
}
